import type { ReactNode } from 'react';

export const symbol_rotate_90_degrees_ccw: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M520-80q-48 0-92.5-12T341-127q-11-6-14.5-18.5T329-169q5-11 17-15t23 2q35 20 73 31t78 11q125 0 212.5-87.5T820-440q0-126-87.5-215T519-744h-31l53 53q9 9 9 21t-9 21q-9 9-21 9t-21-9L395-753q-5-5-7-10t-2-11q0-6 2-11t7-10l104-104q9-9 21-9t21 9q9 9 9 21t-9 21l-53 53h31q151 0 256 106.5T880-440q0 150-105 255T520-80ZM251-234q-5-2-10-7L61-421q-5-5-7-10t-2-11q0-6 2-11t7-10l180-180q5-5 10-7t11-2q6 0 11 2t10 7l180 180q5 5 7 10t2 11q0 6-2 11t-7 10L283-241q-5 5-10 7t-11 2q-6 0-11-2Zm11-68 136-136-136-136-136 136 136 136Zm0-136Z"
		/>
	</svg>
);
